// 게스트(비로그인)가 리딩 화면에 직접 입력한 출생정보를 기억해뒀다가, 나중에 회원가입 폼에
// 자동으로 채워준다("게스트로 이미 사주를 봤다면 그대로 가입 폼에 들어가게"). 로그인 계정과
// 무관한 순수 클라이언트 저장(localStorage)이라 서버에는 남지 않는다.
const KEY = "align-guest-birth";

export type GuestBirthDraft = {
  name?: string;
  gender: "male" | "female";
  year: number; month: number; day: number; hour: number; minute: number;
  unknownTime?: boolean;
  lat: number; lon: number; cityLabel?: string;
};

export function saveGuestBirth(draft: GuestBirthDraft): void {
  try {
    if (!draft || !draft.year || !draft.month || !draft.day) return;
    localStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // 저장 실패해도 리딩 자체엔 영향 없음
  }
}

export function loadGuestBirth(): GuestBirthDraft | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as GuestBirthDraft) : null;
  } catch {
    return null;
  }
}

export function clearGuestBirth(): void {
  try { localStorage.removeItem(KEY); } catch {}
}
